<section class="row">
	<div class="insight-section-separator col-3"></div>
	<section class="col-21">
		<ng-container *ngFor="let component of data | tabSelector: getTabIdForRules():'start'">
			<ate-empty-column-chart
				[height]="240"
				[data]="component"
				[selectedPortfolioIndex]="selectedPortfolioIndex"
				*ngIf="isComponentIdMatched(component, 'empty-column-chart')"
			>
			</ate-empty-column-chart>
			<ate-doughnut-chart [data]="component" [selectedPortfolioIndex]="selectedPortfolioIndex" *ngIf="isComponentIdMatched(component, 'doughnut-chart')">
			</ate-doughnut-chart>
			<ate-fund-holdings
				[isSingleStocksView]="true"
				[showReviewHoldingsLink]="false"
				[data]="component"
				[selectedPortfolioIndex]="selectedPortfolioIndex"
				*ngIf="isComponentIdMatched(component, 'fund-holdings.single-stocks')"
			>
			</ate-fund-holdings>
			<ate-fund-holdings
				[data]="component"
				[showReviewHoldingsLink]="false"
				[selectedPortfolioIndex]="selectedPortfolioIndex"
				*ngIf="isComponentIdMatched(component, 'fund-holdings.mutual-funds')"
			>
			</ate-fund-holdings>
			<ate-indicator-column-chart
				[data]="component"
				[selectedPortfolioIndex]="selectedPortfolioIndex"
				[showDisclaimers]="false"
				[showPeerComparison]="false"
				*ngIf="isComponentIdMatched(component, 'indicator-column-chart')"
			>
			</ate-indicator-column-chart>
		</ng-container>
	</section>
</section>
